import React from "react";
import {FieldAttributes, useField} from "formik";
import "./index.scss";
import {Tooltip} from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {Theme, withStyles} from '@material-ui/core/styles';

interface Props {
    suffix?: string;
    outputValue?: string;
    messageInfoObj: any;
    id?: string
}

const LightTooltip = withStyles((theme: Theme) => ({
    arrow: {
        color: theme.palette.common.white,
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        padding: '15px',
    },
}))(Tooltip) as any;


export const OutputValueFieldInfo = ({id, name, messageInfoObj, outputValue, suffix}: FieldAttributes<Props>) => {
    const [field] = useField({name});

    const [open, setOpen] = React.useState(false);

    return (

        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <LightTooltip
                PopperProps={{
                    disablePortal: true,
                }}
                onClose={() => setOpen(false)}
                open={open}
                arrow
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={messageInfoObj}>
					<span id={id} className={`output-value-pointer__value`}
                          onClick={() => setOpen(!open)}>
				        {outputValue ? outputValue : field.value}{suffix ? suffix : ''}</span>
            </LightTooltip>
        </ClickAwayListener>
    )
};